const events = {
  SCREEN_APPEAR: 'ScreenAppear',
  SET_FILTERS: 'SetFilters',
  SORT: 'Sort',
  SIZE_BAR_APPEAR: 'SideBarAppear',
  BUTTON_CLICK: 'ButtonClick',
};

export let MixpanelEvents = events;
